import { StatusIcon } from "src/base-components/StatusIcon";
import { CaseTemplateVersionPublishState } from "src/clients/case-management/api";

export const TemplateVersionName: React.FC<{
  name: string;
  state: CaseTemplateVersionPublishState;
}> = ({ name, state }) => {
  return (
    <div className="flex items-center gap-1">
      <TemplateVersionStatusIndicator state={state} />
      {name}
    </div>
  );
};

export const TemplateVersionStatusIndicator: React.FC<{
  state: CaseTemplateVersionPublishState;
}> = ({ state }) => {
  return (
    <StatusIcon
      variant={
        state === CaseTemplateVersionPublishState.PUBLISHED
          ? "published"
          : "draft"
      }
    />
  );
};
